import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

// images
import mainBg from '../images/main-bg.jpg'
import logo from '../images/ubx-logo.svg'

// styling
const useStyles = makeStyles({
  header: {
    background: `url(${mainBg}) no-repeat top center`,
    backgroundSize: 'cover',
    padding: '3.75rem 2rem',
    color: '#fff',
    textAlign: 'center',
    position: 'relative',

    '&::before': {
      content: "''",
      display: 'block',
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      background: `linear-gradient(180deg, rgba(27, 27, 27, 0.5) 0%, rgba(27, 27, 27, 0.7) 14.42%, #1B1B1B 77.65%, #1B1B1B 100%)`,
    },

    '& h1': {
      fontSize: '2rem',
      color: '#fff',
      position: 'relative',
      zIndex: 2,
    },
  },
  logo: {
    width: 110,
    height: 'auto',
    margin: '0 auto 3rem',
    position: 'relative',
    zIndex: 2,
  },
  headerContent: {
    display: 'grid',
    gap: '2rem',
    maxWidth: '1100px',
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
  },
})

function Header({ children, isError, title }) {
  const classes = useStyles()
  return (
    <header className={classes.header} style={{ flexGrow: isError ? 1 : 0}}>
      <img src={logo} className={classes.logo} alt="" />
      {title && <h1>{title}</h1>}
      {children && <div className={classes.content}>{children}</div>}
    </header>
  )
}

export default Header
